$(window).on('beforeunload', function () {
    if ($("[unsavedInput='true']").length !== 0) {
        return 'unsaved';
    }
});